import { apiRequest } from 'utils/api';

const SHARED_URL = process.env.REACT_APP_SHARED_API_URL.replace(/\/$/, '');
const NAV_URL = `${SHARED_URL}/navigation`;
const BUSINESS_URL = process.env.REACT_APP_BUSINESS_WEB_URL;

class SharedAPI {
  getSettingsUrls = async () => {
    return await apiRequest(`${NAV_URL}/settingsurls?businessWebBaseUrl=${BUSINESS_URL}`);
  };
}

const api = new SharedAPI();
export default api;



// WEBPACK FOOTER //
// ./src/api/shared.js